<div class="total-container">
  <div class="side-nav">
    <div [ngClass]="collapsed ? 'side-bar collapsed':'side-bar'">
      <div [ngClass]="collapsed ? 'logo-bar center':'logo-bar'">
        <div class="logo-container">
          <img class="logo" src="assets/img/allegion.svg">
        </div>
        @if (!collapsed) {
          <div class="app-title ng-star-inserted"> {{'SIDEBAR.am_title' | translate }} </div>
        }
      </div>
      <div class="scroll-bar">
        <div class="left-bar-scroll">
          <div class="buttons-wrapper bar-padding">
            <div class="top-buttons">
              @for (navButton of navButtons; track navButton; let i = $index) {
                <div>
                  <span class="btn" [matTooltip]="navButton.name" [matTooltipDisabled]="!collapsed" [ngClass]="{'btn-active':navButton.active === true}"
                    (click)="changeRoute(navButton)">
                    <mat-icon fontSet="material-icons-outlined"
                      [ngClass]="{'btn-active':navButton.active === true}">{{navButton.icon}}</mat-icon>
                    @if (!collapsed) {
                      <span class="content btn-content-icon"
                        [ngClass]="{'btn-active':navButton.active === true}">{{navButton.name}}</span>
                    }
                  </span>
                </div>
              }
            </div>
            <div class="bottom-buttons">
              <span class="btn btn-collapsed" (click)="changeCollapse()" >
                @if (collapsed) {
                  <mat-icon>arrow_forward</mat-icon>
                }
                @if (!collapsed) {
                  <mat-icon>arrow_back</mat-icon>
                }
                @if (!collapsed) {
                  <span class="content btn-content-icon">{{ 'SIDEBAR.collapse' | translate }}</span>
                }
              </span>
            </div>
          </div>
          <div class="side-bar-footer">
            <div [matTooltip]=" 'SUPPORT.support' | translate " class="support" [matTooltipDisabled]="!collapsed" (click)="openSupportDetailsDialog()"><mat-icon>help_outline</mat-icon>@if (!collapsed) {<span class="btn-content-icon content">{{ 'SUPPORT.support' | translate }}</span>}</div>
            <div #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="appMenu">
            <span [matTooltip]="user?.name" [matTooltipDisabled]="!collapsed" class="btn-chip">
              <div style="display:flex">
                <div class="chip chip-round chip-small avatar-icon">
                  <span>{{user?.initials}} </span>
                </div>
              </div>
              @if (!collapsed) {
                <span class="content icon btn-content-chip btn-content-icon"> {{user?.name}} </span>
              }
            </span>
            <mat-menu [class]="collapsed ? 'menu-bar' : 'menu-bar extra-padding'" #appMenu="matMenu">
              <div class="profile-menu">
                <div class="chip chip-round chip-small">
                  <span> {{user?.initials}} </span>
                </div>
                <div class="profile-details">
                  <span class="user-name">{{user?.name}}</span>
                  <span class="user-details">{{user?.email}}</span>
                </div>
              </div>
              @for (profileItem of profileActions; track profileItem) {
                <span mat-menu-item (click)="profileAction(profileItem)">
                  <mat-icon>{{profileItem.icon}}</mat-icon>
                  <span class="icon-left">{{profileItem.name}}</span>
                </span>
              }
            </mat-menu>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="app-container">
    <div class="scroll">
      <div class="my-app-padding">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>